import { toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, withModifiers as _withModifiers, createBlock as _createBlock } from "vue"

const _hoisted_1 = { key: 0 }
const _hoisted_2 = { key: 1 }
const _hoisted_3 = { class: "links" }
const _hoisted_4 = { class: "button-grid" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_LinkIcon = _resolveComponent("LinkIcon")!
  const _component_CloseIcon = _resolveComponent("CloseIcon")!
  const _component_NcActionButton = _resolveComponent("NcActionButton")!
  const _component_NcListItem = _resolveComponent("NcListItem")!
  const _component_XLoadingIcon = _resolveComponent("XLoadingIcon")!
  const _component_NcButton = _resolveComponent("NcButton")!
  const _component_Modal = _resolveComponent("Modal")!

  return (_ctx.show)
    ? (_openBlock(), _createBlock(_component_Modal, {
        key: 0,
        ref: "modal",
        onClose: _ctx.cleanup,
        size: "normal",
        sidebar: _ctx.sidebar
      }, {
        title: _withCtx(() => [
          _createTextVNode(_toDisplayString(_ctx.t('memories', 'Link Sharing')), 1)
        ]),
        buttons: _withCtx(() => [
          _createElementVNode("div", _hoisted_4, [
            _createVNode(_component_NcButton, {
              class: "primary",
              disabled: _ctx.loading,
              onClick: _ctx.createLink
            }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(_ctx.t('memories', 'Create Link')), 1)
              ]),
              _: 1
            }, 8, ["disabled", "onClick"]),
            _createVNode(_component_NcButton, {
              class: "primary",
              disabled: _ctx.loading,
              onClick: _ctx.refreshUrls
            }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(_ctx.t('memories', 'Refresh')), 1)
              ]),
              _: 1
            }, 8, ["disabled", "onClick"])
          ])
        ]),
        default: _withCtx(() => [
          (_ctx.isRoot)
            ? (_openBlock(), _createElementBlock("div", _hoisted_1, _toDisplayString(_ctx.t('memories', 'You cannot share the root folder')), 1))
            : (_openBlock(), _createElementBlock("div", _hoisted_2, [
                _createTextVNode(_toDisplayString(_ctx.t('memories', 'Public link shares are available to people outside Nextcloud.')) + " ", 1),
                _cache[0] || (_cache[0] = _createElementVNode("br", null, null, -1)),
                _createTextVNode(" " + _toDisplayString(_ctx.t('memories', 'You may create or update permissions on public links using the sidebar.')) + " ", 1),
                _cache[1] || (_cache[1] = _createElementVNode("br", null, null, -1)),
                _createTextVNode(" " + _toDisplayString(_ctx.t('memories', 'Click a link to copy to clipboard.')), 1)
              ])),
          _createElementVNode("div", _hoisted_3, [
            _createElementVNode("ul", null, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.shares, (share) => {
                return (_openBlock(), _createBlock(_component_NcListItem, {
                  name: share.label || _ctx.t('memories', 'Share link'),
                  key: share.id,
                  bold: false,
                  href: share.url,
                  compact: true,
                  onClick: _withModifiers(($event: any) => (_ctx.shareOrCopy(share.url)), ["prevent"])
                }, {
                  icon: _withCtx(() => [
                    _createVNode(_component_LinkIcon, {
                      class: "avatar",
                      size: 20
                    })
                  ]),
                  subname: _withCtx(() => [
                    _createTextVNode(_toDisplayString(_ctx.getShareLabels(share)), 1)
                  ]),
                  actions: _withCtx(() => [
                    _createVNode(_component_NcActionButton, {
                      onClick: ($event: any) => (_ctx.deleteLink(share)),
                      disabled: _ctx.loading
                    }, {
                      icon: _withCtx(() => [
                        _createVNode(_component_CloseIcon, { size: 20 })
                      ]),
                      default: _withCtx(() => [
                        _createTextVNode(_toDisplayString(_ctx.t('memories', 'Remove')) + " ", 1)
                      ]),
                      _: 1
                    }, 8, ["onClick", "disabled"])
                  ]),
                  _: 2
                }, 1032, ["name", "href", "onClick"]))
              }), 128))
            ])
          ]),
          (_ctx.loading)
            ? (_openBlock(), _createBlock(_component_XLoadingIcon, { key: 2 }))
            : _createCommentVNode("", true)
        ]),
        _: 1
      }, 8, ["onClose", "sidebar"]))
    : _createCommentVNode("", true)
}